// src/components/modals/AppBootStrap.jsx
const INITIAL_SETUP_KEY = 'app-setup-completed';
const LANG_KEY = 'app-lang-selected';

export const runInitialLanguageCheck = () => {
    const setupStatus = localStorage.getItem(INITIAL_SETUP_KEY);
    const langStatus = localStorage.getItem(LANG_KEY);

    const needsSetup = !setupStatus || setupStatus === 'PENDING';
    const needsLang = !langStatus || langStatus === 'PENDING';

    if (needsSetup || needsLang) {
        // 1. Update storage first
        if (needsSetup) localStorage.setItem(INITIAL_SETUP_KEY, 'PENDING');
        if (needsLang) localStorage.setItem(LANG_KEY, 'PENDING');

        console.log("BOOTSTRAP: Conditions met. Dispatching event...");

        // 2. Wrap in a timeout to ensure Modal.jsx is mounted and listening
        setTimeout(() => {
            window.dispatchEvent(new CustomEvent('trigger-lang-modal'));
        }, 100); 

        return true;
    } 
    
    return false;
};